<template>
  <survey-page :questions="questions"
               :question-types="questionTypes"
               :page-title="`היי ${this.householdName()},`"
               :pageSubTitle="'רק עוד 3 תשובות וסיימנו 🙂'"
               :set-answer="setAnswer"
               :buttonTitle="'סיימתי'"
               :buttonAction="saveSurveyAnswers"/>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import Segment from '../../../../../Segment';
import SurveyPage from '../../../../../base-components/survey/SurveyPage.vue';

export default {
  name: 'ActivationSurveyFirstPage',
  props: {
    questions: {
      type: Array,
      required: true,
    },
  },
  components: {
    SurveyPage,
  },
  computed: {
    ...mapState('activationSurvey', ['questionTypes']),
  },
  methods: {
    ...mapGetters('session', ['householdName']),
    ...mapActions('activationSurvey', ['setAnswer', 'saveAnswers']),
    async saveSurveyAnswers() {
      Segment.trackUserInteraction('ActivationSurveyAnsweredClicked', {});
      await this.saveAnswers();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
